export interface FeatureToggleResponse {
    name: string;
    isEnabled: boolean;
}

export class FeatureToggle {
    id: number;
    name: string;
    isEnabled = false;

    private constructor(id: number, name: string) {
        this.id = id;
        this.name = name;
    }

    public static asArray = () => [];

    public static byId = (id: number) =>
        FeatureToggle.asArray().find(feature => feature.id === id);

    public static setFeatures = (featureToggles: FeatureToggleResponse[]) => {
        FeatureToggle.asArray().forEach(feature => {
            const fromBE = featureToggles.find(
                f => f.name.toLowerCase() === feature.name.toLowerCase()
            );
            feature.isEnabled = fromBE?.isEnabled || false;
        });
    };
}
